<template>
  <my-header></my-header>
  <router-view></router-view>
</template>

<script>
  export default {}
</script>
